// The two requests, and why neither of them preflights.
//
// Both are CORS-simple: a GET with no custom headers, and a POST whose body is
// URLSearchParams -- which makes the Content-Type
// application/x-www-form-urlencoded, one of the three safelisted values. So the
// browser never sends an OPTIONS, every submission is one round trip, and Rails
// parses the body into params with no work at all. Sending JSON with
// Content-Type: application/json would cost a preflight on every single
// submission for nothing.
//
// credentials: "omit" is not incidental either: it is what lets the server
// answer Access-Control-Allow-Origin: *. The moment credentials are included
// the wildcard becomes illegal and every customer would need their own origin
// allowlist, kept in step with whatever domain they moved their site to. There
// is nothing to authenticate here -- the token is the whole identification.

const TIMEOUT = 15000

export function fetchConfig(origin, token) {
  return request(`${origin}/embed/v1/form/${encodeURIComponent(token)}`, {
    method: "GET",
    headers: { Accept: "application/json" }
  })
}

export function submit(url, values) {
  const body = new URLSearchParams()
  Object.keys(values).forEach((key) => {
    const value = values[key]
    if (value === null || value === undefined) return

    // A tick-box group is several values under one name. Appended one at a
    // time, which is what a browser's own form serialization does and what
    // Rails parses back into an Array. Assigning the Array straight in
    // stringifies it to "a,b" and Rails sees one value with a comma in it.
    if (Array.isArray(value)) {
      value.forEach((one) => body.append(key, one))
      return
    }

    body.append(key, value)
  })

  return request(url, { method: "POST", headers: { Accept: "application/json" }, body })
}

function request(url, options) {
  const controller = new AbortController()
  const timer = setTimeout(() => controller.abort(), TIMEOUT)

  return fetch(url, {
    credentials: "omit",
    mode: "cors",
    signal: controller.signal,
    ...options
  })
    .then((response) =>
      response
        .json()
        .catch(() => null)
        .then((body) => ({ status: response.status, ok: response.ok, body }))
    )
    .finally(() => clearTimeout(timer))
}
